/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class t{constructor(t){this._statistics=t}get statistics(){return this._statistics}}export{t as AAggregateCell};
